import { useMutation, useQueryClient } from "@tanstack/react-query";

import { exploreImagesQueryKey } from "@/hooks/queries/useGetExploreImages";
import { guacHttpClient } from "@/lib/http";
import {
  ExploreImage,
  ExploreImageIndustry,
  HttpResponse,
  PositionCategory,
} from "@/types";

export function useUploadExploreImage() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    // Arrays go out as `field[]` form entries, which guac reads as lists.
    mutationFn: async (body: {
      image: File;
      positionCategories: PositionCategory[];
      caption: string;
      keywords: string[];
      industries: ExploreImageIndustry[];
    }) => {
      const res = await guacHttpClient.postForm<
        ExploreImage,
        HttpResponse<ExploreImage>
      >("explore-images", body);

      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: exploreImagesQueryKey });
    },
  });

  return mutation;
}
